import React, { useContext, useRef, useState } from 'react';
import message from 'antd/lib/message';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { useQuery } from 'react-query';
import { FirebaseContext } from '../../context/FirebaseContext';
import { getNumbers } from '../../NecttosComp/APICaller/ApiServices';
import { Main, Header, Body } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import { Table, Tbody, Td, Th, Thead, Tr } from '../../NecttosComp/Table/Table';
import Input2 from '../../NecttosComp/Input/Input2';
import Instruction from '../../Documentation/Instruction';

export const Numbers = ({ onClose }) => {
  const { collegeId, collegeList } = useContext(FirebaseContext);
  const componentRef = useRef();
  const selectedCollege = collegeList?.find((x) => x.collegeId === collegeId);
  let { data = [], refetch } = useQuery('getNumbers', getNumbers(collegeId));
  const [isLoading, setIsLoading] = useState(false);
  const [state, setState] = useState({});
  const [adding, setAdding] = useState(false);

  const manageHolidays = async () => {
    try {
      setIsLoading(true);
      const instance = await getAxiosTokenInstance();

      const resp = await instance.post('/college/action/postNumber', {
        _id: state?._id || '',
        collection: state?.collection || '',
        number: state?.number || '',
        type: state?.type || '',
      });

      if (resp.data.statusCode !== 200) {
        throw new Error(resp.data.message || 'API Error');
      }

      setState({ _id: '', collection: '', number: '', type: '' });
      refetch();
    } catch (error) {
      message.error(error?.response?.data?.message || error?.message || 'API Error');
    } finally {
      setIsLoading(false);
    }
  };

  data = data?.sort((a, b) => a?.name?.localeCompare(b?.name));

  return (
    <Main title="Continuation Number Management" width='90vw' height='90vh'>
      <Header>
        <div className="flex"></div>
        <div className="flex gap-2">
          <Button type="refresh" onClick={refetch}>Reload</Button>
          <Instruction keyId={'numbers'}></Instruction>
          <Button type="print" tableRef={componentRef.current}>Print</Button>
          <Button type="close" onClick={onClose}>Close</Button>
        </div>
      </Header>

      <Body>
        <div ref={componentRef} className="printable relative">
          <img
            className="absolute w-4/5 mt-64 left-1/2 -translate-x-1/2 opacity-10 -z-10"
            src={selectedCollege?.logo}
            alt="College Watermark"
          />

          <Table width="100%"  innerWidth={['15%', '40%', '35%', '10%']}>
            <Thead>
              <Tr>
                <Th position={0}>Sn</Th>
                <Th position={1}>Types of Fees</Th>
                <Th position={2}>Next Number</Th>
                <Th position={3}>Actions</Th>
              </Tr>
            </Thead>
            <Tbody>
              {data?.map((item, i) => (
                <Tr key={i}>
                  <Td index={i} position={0}>{i + 1}</Td>
                  <Td index={i} position={1}>{item.type.toUpperCase()}</Td>
                  <Td index={i} position={2}>{item.number}</Td>
                  <Td index={i} position={3}>
                    <div className='print:hidden flex justify-center'>
                    <Button
                      type="edit"
                      onClick={() => {
                        setState({
                          _id: item?._id || '',
                          collection: item?.collection || '',
                          number: item?.number || '',
                          type: item?.type || '',
                        });
                        setAdding(true);
                      }}
                    >
                      Edit
                    </Button>
                    </div>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </div>
      </Body>

      {adding && (
        <Main
          height="350px"
          width="40%"
          title={state?.type ? `Edit ${state?.type?.toUpperCase()}` : 'Edit'}
        >
          <Body>
            <div className="flex flex-col h-full w-full rounded-2xl overflow-y-scroll shadow-md p-6">
              <h3 className="text-xl mb-0 text-center font-black dark:text-white">
                {state?.alert ? state.alert : 'Edit'}
              </h3>

              <Input2
                type="number"
                returnKey="number"
                fieldName="Edit Number"
                state={state}
                setState={setState}
              />
            </div>
          </Body>

          <div className="flex justify-around self-center mt-4 mb-2">
            <Button
              type="close"
              onClick={() => {
                setState({ _id: '', collection: '', number: '', type: '' });
                setAdding(false);
              }}
            >
              Cancel
            </Button>

            <Button
              type="update"
              onClick={() => {
                manageHolidays();
                setAdding(false);
              }}
            >
              Update
            </Button>
          </div>
        </Main>
      )}
    </Main>
  );
};

export default Numbers;
  